
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.333 7.334h-1.596c.16-.318.25-.667.263-1.022A2.4 2.4 0 0015.555 4 4.142 4.142 0 0012 6.345 4.123 4.123 0 008.467 4H8.39A2.396 2.396 0 006 6.312v.044c.013.34.1.674.253.978H4.667A.667.667 0 004 8v2a.667.667 0 00.667.667h14.666A.667.667 0 0020 10V8a.666.666 0 00-.667-.666zm-3.757-2a1.067 1.067 0 011.09.978 1.059 1.059 0 01-1.05 1.022h-2.63c.414-.84 1.239-2 2.59-2zm-8.243 1a1.067 1.067 0 011.076-1c1.38.005 2.188 1.154 2.607 2h-2.6a1.077 1.077 0 01-1.083-1zM13.334 12v8h3.333a2 2 0 002-2v-6h-5.334zM10.667 12H5.334v6a2 2 0 002 2h3.333v-8z","fill":"#4788C6"}})])
          )
        }
      }
    